var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('fieldset', [_c('legend', [_vm._v("User hub mapping")]), _vm._v(" "), _c('form', {
    staticClass: "form-group col-md-12 access_form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-md-2 float-md-left"
  }, [_c('label', [_vm._v("Hub Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 float-md-left"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('HubName')
    },
    attrs: {
      "name": "HubName",
      "id": "HubName",
      "options": _vm.listHubsData,
      "multiple": true,
      "label": "HubName",
      "track-by": "HubName",
      "placeholder": "Type to search"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('span', {
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Consider changing the search query.")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubName')),
      expression: "errors.has('HubName')"
    }],
    staticClass: "text-danger float-md-left col-md-12"
  }, [_vm._v("Please select hubs.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-md-2 float-md-left"
  }, [_c('label', [_vm._v("Add Hub")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.HubOps),
      expression: "HubOps"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('HubOps')
    },
    attrs: {
      "type": "radio",
      "id": "addHub",
      "value": "add",
      "name": "HubOps"
    },
    domProps: {
      "checked": _vm._q(_vm.HubOps, "add")
    },
    on: {
      "__c": function($event) {
        _vm.HubOps = "add"
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 float-md-left"
  }, [_c('label', [_vm._v("Remove Hub")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.HubOps),
      expression: "HubOps"
    }],
    class: {
      'error': _vm.errors.has('HubOps')
    },
    attrs: {
      "type": "radio",
      "id": "removeHub",
      "name": "HubOps",
      "value": "remove"
    },
    domProps: {
      "checked": _vm._q(_vm.HubOps, "remove")
    },
    on: {
      "__c": function($event) {
        _vm.HubOps = "remove"
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubOps')),
      expression: "errors.has('HubOps')"
    }],
    staticClass: "text-danger float-md-left col-md-12"
  }, [_vm._v("Please select one from add or remove hub.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 float-md-left"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {}, [_vm._v("Apply change for all project")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "change": function($event) {
        _vm.checkAll()
      },
      "__c": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('ul', _vm._l((_vm.assignedProjects), function(project_obj, index) {
    return _c('li', {
      staticClass: "row col-md-12 float-md-left wrapper_form"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.projectids),
        expression: "projectids"
      }],
      class: {
        'error': _vm.errors.has('projectids')
      },
      staticStyle: {
        "font-weight": "100"
      },
      attrs: {
        "type": "checkbox",
        "name": "projectids",
        "id": project_obj.projectid
      },
      domProps: {
        "value": project_obj.projectid,
        "checked": Array.isArray(_vm.projectids) ? _vm._i(_vm.projectids, project_obj.projectid) > -1 : (_vm.projectids)
      },
      on: {
        "change": function($event) {
          _vm.updateCheckall()
        },
        "__c": function($event) {
          var $$a = _vm.projectids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = project_obj.projectid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.projectids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.projectids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.projectids = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(project_obj.projectname)), _c('br')])
  }))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('projectids')),
      expression: "errors.has('projectids')"
    }],
    staticClass: "text-danger float-md-left col-md-12"
  }, [_vm._v("Please select one project.")])])]), _vm._v(" "), _c('div', {
    staticClass: "userfooter form-actions float-md-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "vlg"
    }
  }, [_vm._v("Save")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "vlg"
    }
  }, [_vm._v("Cancel")])])])])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d396ca4","hasScoped":true}!./src/views/components/mappinguserhub/mappinguserhub.component.html
// module id = 871
// module chunks = 1